import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';

import TopNavBar from '../../containers/top-nav-bar.container';
import Footer from '../../containers/footer.container';
import PurchaseTitle from './purchase-title';
import PurchaseKeyInfo from '../../containers/purchase-key-info.container';
import ShareSummary from '../../containers/make-purchase/share-summary.container';
import MakePurchaseSummary from './make-purchase-summary';
import RefundSummary from '../../containers/refund-summary.container';
import OrganizerShareBreakdown from '../../containers/organizer-share-breakdown.container';
import InviteesShareBreakdown from '../../containers/make-purchase/invitees-share-breakdown.container';
import RemoveFromPurchase from '../../containers/remove-from-purchase.container';
import PaymentSent from '../../containers/make-purchase/payment-sent.container';
import Modal from '../modal';
import Purchase from '../../lib/purchase';
import Membership from '../../lib/membership';
import '../../css/make-purchase.css';

class MakePurchase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disableMakePayment: false,
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.onCloseRemoveModalClick = this.onCloseRemoveModalClick.bind(this);
    this.onClosePaymentSentClick = this.onClosePaymentSentClick.bind(this);
  }

  onCloseRemoveModalClick() {
    this.props.onCloseRemoveModalClick();
  }

  onClosePaymentSentClick() {
    this.props.onClosePaymentSentClick();
    this.setState({
      disableMakePayment: false,
    });
  }

  onSubmit(props) {
    this.setState({
      disableMakePayment: true,
    }, () => {
      this.props.onSubmit(props);
    });
  }

  showingRemoveModal() {
    return this.props.isRemoveModalVisible;
  }

  showingPaymentSubmittedModal() {
    return this.props.isPaymentSentModalVisible;
  }

  paymentsCount() {
    return this.props.purchase.payments.length;
  }

  get currentPaymentIndex() {
    const { currentPayment } = this.props.purchase;
    return currentPayment.number;
  }

  renderDetails() {
    const { purchase } = this.props;

    return (
      <div className="purchase-info">
        <div className="row mb-4">
          <PurchaseTitle title={purchase.product.name} />
        </div>
        <PurchaseKeyInfo />
      </div>
    );
  }

  renderHeadingTitle() {
    const { purchase } = this.props;

    if (Purchase.isSinglePayment(purchase.payments) || Purchase.isCurrentPaymentLastPayment(purchase)) {
      return (
        <FormattedMessage
          id="makePurchase.headingTitle.almostThere"
          defaultMessage='Almost there!'
        />
      );
    }

    return (
      <FormattedMessage
        id="makePurchase.headingTitle.makingPayment"
        defaultMessage="Making payment {number} of {count}"
        values={{ number: this.currentPaymentIndex, count: this.paymentsCount() }}
      />
    );
  }

  renderSidebar() {
    return (
      <MakePurchaseSummary
        purchase={this.props.purchase}
        submitting={this.state.disableMakePayment}
      />
    );
  }

  renderRemoveModal() {
    if (!this.showingRemoveModal()) return null;

    return (
      <Modal width="remove-modal" onClose={this.onCloseRemoveModalClick}>
        <RemoveFromPurchase />
      </Modal>
    );
  }

  renderPaymentSentModal() {
    if (!this.showingPaymentSubmittedModal()) return null;

    return (
      <Modal width="modal-md" onClose={this.onClosePaymentSentClick}>
        <PaymentSent />
      </Modal>
    );
  }

  render() {
    const { handleSubmit, organizerMembership } = this.props;

    return (
      <div>
        <TopNavBar />
        <div className="container make-purchase mt-4">
          <div className="make-purchase-sidebar sticky-top flex-last">
            <div className="make-purchase-summary">
              <form onSubmit={handleSubmit(this.onSubmit)}>
                {this.renderSidebar()}
              </form>
            </div>
          </div>
          <div className="make-purchase-body flex-first">
            <div className="main-container pb-4">
              <div className="header container rounded-top">
                {this.renderHeadingTitle()}
              </div>
              <div className="px-5 divider mb-5">
                {this.renderDetails()}
              </div>
              <div className="px-5">
                <ShareSummary />
              </div>
              <div className="px-5">
                <RefundSummary />
              </div>
              {
                Membership.isCommitted(organizerMembership.status) && (
                  <div className="px-5 mt-4">
                    <OrganizerShareBreakdown />
                  </div>
                )
              }
              <div className="px-5 mt-5">
                <InviteesShareBreakdown />
              </div>
            </div>
          </div>
          <div className="clearfix" />
        </div>
        {this.renderRemoveModal()}
        {this.renderPaymentSentModal()}
        <Footer />
      </div>
    );
  }
}

MakePurchase.defaultProps = {
  purchase: null,
  user: null,
  authentication: null,
  organizerUser: null,
  invitees: [],
  organizerMembership: null,
  isRemoveModalVisible: false,
  onSubmit: () => { },
  onCloseRemoveModalClick: () => { },
};


export default reduxForm({
  form: 'makePurchase',
})(MakePurchase);



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/index.js